let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hedhZ")).then(() => parcelRequire('vyZB6'));